'use client';

import { useOptions } from '@/providers/options';

export function BottomAds() {
  const options = useOptions();

  if (options.showAds && options.bottomAds) {
    return options.bottomAds;
  }

  // TODO: Add placeholder if no ads and there should be
  return null;
}
